import Vue from "vue"
import axios from './axios'

export default {
  init() {
    axios.interceptors.request.use(config => {
      Vue.$log.info("== onRequest ==", config);
      return config;
    });
    axios.interceptors.response.use(function (response) {
      Vue.$log.info("== onResponse ==", response);
      return response
    })
  }
}

